import { setContext } from 'apollo-link-context';
import { merge } from 'lodash-es';

import { getCurrentUserSession } from 'remote/auth';

const getTokenFromSession = (session: any): string => {
  if (session.getIdToken) {
    return session.getIdToken().getJwtToken();
  }
  if (session.tokens?.idToken) {
    return session.tokens.idToken.toString();
  }
  return '';
};

export const withAuthToken = setContext(async (_, previousContext) => {
  const session = await getCurrentUserSession();
  if (!session) {
    return previousContext;
  }

  const token = getTokenFromSession(session);
  if (!token) {
    return previousContext;
  }

  const headers = {
    authorization: `Bearer ${token}`,
  };

  return merge({ headers }, previousContext);
});
